"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Events fired by the widget.
 */
var WidgetEvents;
(function (WidgetEvents) {
    WidgetEvents["STEP_BACK"] = "step back";
    WidgetEvents["STEP_NEXT"] = "next step";
    WidgetEvents["STEP_SKIPPED"] = "step skipped";
    WidgetEvents["STEP_LOADING"] = "step loading";
    WidgetEvents["STEP_RENDERED"] = "step rendered";
    WidgetEvents["STEP_READY"] = "step ready";
    WidgetEvents["STEP_UNLOAD"] = "step unload";
    WidgetEvents["FINALIZED"] = "steps completed";
    WidgetEvents["ERROR"] = "error";
    WidgetEvents["HANDLED_ERROR"] = "handled error";
    WidgetEvents["INTERNAL_ERROR"] = "internal error";
    WidgetEvents["UPDATED"] = "updated";
})(WidgetEvents = exports.WidgetEvents || (exports.WidgetEvents = {}));
